/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-danger[_ngcontent-%COMP%]{color:#fffffc;background-color:#b51b0c;border-color:#8c1004;font-size:12px;font-weight:600;padding:8px 24px;text-align:center;margin-top:6px;margin-bottom:0;left:119px}.m-l8[_ngcontent-%COMP%]{margin-left:8px}"];
export { styles as styles };
